import React from "react";

// White in both themes on purpose: brand logos are drawn for light backgrounds
// and several turn illegible on a dark surface. bg-[#fff], not bg-white:
// styles/dark-legacy-shim.css repaints .bg-white with the dark surface colour.
const ChannelLogo = ({
  src,
  className = "",
  imgClassName = "max-h-[88%] max-w-[88%]",
}) => (
  <div
    className={`flex flex-none items-center justify-center overflow-hidden border-[1px] bg-[#fff] ${className}`}
  >
    <img src={src} alt="" className={`object-contain ${imgClassName}`} />
  </div>
);

// Logo + name, as the first cell of the list-view tables.
export const ChannelNameCell = ({ channel }) => (
  <div className="flex items-center gap-2.5">
    <ChannelLogo
      src={channel.logo}
      className="h-8 w-14 rounded-md border-ui-border"
      imgClassName="max-h-[78%] max-w-[78%]"
    />
    <span className="whitespace-nowrap text-[13px] font-semibold text-ui-text">
      {channel.name}
    </span>
  </div>
);

export default ChannelLogo;
